class GoBackDataService {
  constructor() {}

  setDataSeeConditions(dataConditions) {
    this.step = dataConditions.step;
    this.loan = dataConditions.loan;
    this.simulation = dataConditions.simulation;
    this.backSimulation = dataConditions.backSimulation;
    this.loanPurposes = dataConditions.loanPurposes;
    this.housingChange = dataConditions.housingChange;
    this.housingLoan = dataConditions.housingLoan;
    this.isVariousCredit = dataConditions.isVariousCredit;
  }

  getDataSeeConditions() {
    if (this.loan) {
      return {
        step: this.step,
        loan: this.loan,
        simulation: this.simulation,
        backSimulation: this.backSimulation,
        loanPurposes: this.loanPurposes,
        housingChange: this.housingChange,
        housingLoan: this.housingLoan,
        isVariousCredit: this.isVariousCredit
      };
    }

    return undefined;
  }

  setDataBackToSignUp(dataBackToSignUp) {
    this.loanSignUp = dataBackToSignUp.loan;
    this.createLoanSuccessSignUp = dataBackToSignUp.createLoanSuccess;
    this.createLoanErrorSignUp = dataBackToSignUp.createLoanError;
    this.errorMessageSignUp = dataBackToSignUp.errorMessage;
    this.loanResponseId = dataBackToSignUp.loanResponseId;
    this.backSimulationSignUp = dataBackToSignUp.backSimulation;
    this.fromSignUp = dataBackToSignUp.from;
  }

  getDataBackToSignUp() {
    if (!this.loanSignUp) {
      return undefined;
    }

    return {
      step: 'resume',
      loan: this.loanSignUp,
      createLoanSuccess: this.createLoanSuccessSignUp,
      createLoanError: this.createLoanErrorSignUp,
      errorMessage: this.errorMessageSignUp,
      loanResponseId: this.loanResponseId,
      backSimulation: this.backSimulationSignUp,
      from: this.fromSignUp,
    };
  }

  setHideOrShowButtonCadastralSignUp(data) {
    this.hideButtonCadastral = data;
  }

  getHideOrShowButtonCadastralSignUp() {
    return this.hideButtonCadastral;
  }
}

export default GoBackDataService;


// WEBPACK FOOTER //
// ./client/app/loans.module/common/services/loans.goBackData.service.js